import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { forwardRef } from "react";

import {
  type TNavigationMenuListElement,
  type TNavigationMenuListProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuList = forwardRef<
  TNavigationMenuListElement,
  TNavigationMenuListProps
>(({ className, ...props }, ref) => (
  <NavigationMenuPrimitive.List
    ref={ref}
    data-component="NavigationMenuList"
    className={cn(
      "group flex flex-1 list-none items-center justify-center",
      className,
    )}
    {...props}
  />
));

NavigationMenuList.displayName = NavigationMenuPrimitive.List.displayName;
